<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title class="font18 font600 text-color">
      {{
        catlogType === "flight_book"
          ? ("modals.dynamic_form_modal.passenger_details" | translate)
          : ("modals.dynamic_form_modal.request_form" | translate)
      }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" color="dark" (click)="closeModal()">
        <ion-icon
          slot="icon-only"
          name="close"
          class="primary-icon-color"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-card
    *ngIf="serviceObject"
    lines="none"
    class="border-r10 ion-no-margin card-white-background-color service-card ion-margin-bottom ion-padding"
  >
    <div
      class="ion-text-capitalize grey-border-bottom padb8 ion-margin-bottom card-secondary-text-color fs-3 font400"
      *ngIf="serviceObject?.airportData?.name"
    >
      {{ serviceObject?.airportData?.name }}
    </div>
    <div class="service-content">
      <div class="service-img">
        <img
          src="{{ serviceObject?.img ? serviceObject?.img : imagePlaceholder }}"
          (ionError)="serviceObject.img = imagePlaceholder"
          alt=""
        />
      </div>
      <div class="ion-padding-horizontal service-info">
        <div class="service-card-title marb5">
          <div class="title-text">
            <div class="ion-padding-bottom">
              <span class="card-primary-text-color fs-4 font600">
                {{ serviceObject?.title }}
              </span>
              <div
                class="ion-text-capitalize card-secondary-text-color fs-3 font500"
              >
                {{ selectedLocation }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-card>
  <ng-container
    *ngIf="
      catlogType === 'intl_travel_ins' || catlogType === 'travel_ins' || catlogType === 'trip_insurance';
      else dynamicForm
    "
  >
    <dynamic-form-ins
      [catlogType]="catlogType"
      [selectedPassenger]="selectedPassenger"
      [offersObject]="offersObject"
      [selectedLocation]="selectedLocation"
      [locationList]="locationList"
      [priceInfo]="priceInfo"
      [airportCode]="airportCode"
      [travel_date]="travel_date"
      [access_time]="access_time"
      [selectedLengthOfStay]="selectedLengthOfStay"
      [selectedGuest]="selectedGuest"
      (submitData)="submitRequest($event)"
    ></dynamic-form-ins>
  </ng-container>

  <ng-template #dynamicForm>
    <dynamic-form
      [catlogType]="catlogType"
      [selectedPassenger]="selectedPassenger"
      [offersObject]="offersObject"
      [selectedLocation]="selectedLocation"
      [locationList]="locationList"
      [priceInfo]="priceInfo"
      [airportCode]="airportCode"
      [travel_date]="travel_date"
      [access_time]="access_time"
      [selectedLengthOfStay]="selectedLengthOfStay"
      [selectedGuest]="selectedGuest"
      (submitData)="submitRequest($event)"
    ></dynamic-form>
  </ng-template>
</ion-content>
